module.exports = {
    plan: 'Omni-D',
    startDate: new Date(2016, 11, 1, 0, 0, 0, 0),
    endDate: new Date(2017, 11, 1, 0, 0, 0, 0),
    cloudStorageTotal: 50 * 1024 * 1024 * 1024, // 50 GB
    cloudBandwidthTotal: 200 * 1024 * 1024 * 1024, // 200 GB
    totalDeviceId: 250, // subscription + perpetual
    totalPremiumUserId: 2800, // subscription + perpetual
    planStatus: 'active', // only active, warning, inactive, restricted are accepted or leave empty if no subscription
    hasPerpetual: true, // only true, false
    hasOnPrem: true, // only true, false
    planDescription:
        'Includes Public Cloud, on-prem or hybrid access to all Appspace clients and extensions, up to 250 Devices, 1250 Platform Users, Advanced Support, up to 50 GB storage, up to 50 GB/month bandwidth'
};



// WEBPACK FOOTER //
// ./modules/license/services/licenseOverviewService.planInfoSummary.mock.js